import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import type { InviteUserPayload } from './proposal-part.types';
import { ProposalShell } from './ProposalShell';

interface Props {
  proposalId: string;
  payload: InviteUserPayload;
  resolved?: string | undefined;
  onConfirm: (proposalId: string) => void;
  onCancel: (proposalId: string) => void;
}

/**
 * Confirmation card for one invitation: the address, and the org unit with the head flag,
 * so the user sees where the person lands before confirming.
 */
export function InviteUserProposalCard({
  proposalId,
  payload,
  resolved,
  onConfirm,
  onCancel
}: Props) {
  const t = useFeatureTranslation('aiChat');
  const { email, orgUnitLabel, asOrgUnitManager } = payload;

  return (
    <ProposalShell
      title={t('proposals.invite-user.title')}
      description={t('proposals.invite-user.description')}
      proposalId={proposalId}
      resolved={resolved}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <div className='flex flex-col gap-2xs'>
        <span className='text-foreground-base text-sm'>{email}</span>
        {orgUnitLabel && (
          <span className='text-foreground-subtle text-sm'>
            {asOrgUnitManager
              ? t('proposals.invite-user.orgUnitAsHead', { label: orgUnitLabel })
              : t('proposals.invite-user.orgUnit', { label: orgUnitLabel })}
          </span>
        )}
      </div>
    </ProposalShell>
  );
}
